<template>
  <b-card class="mb-5">
    <h3 class="border-bottom pb-3">Profile</h3>
    <form v-on:submit.prevent="doSubmit" class="mt-2">
      <b-row>
        <b-col md="5" class="border-right">
          <card class="stacked-form">
            <l-progress v-if="isLoading" :value="100" :height="20" class="mb-2" type="info" :animated="true" :striped="true"></l-progress>
            <div class="mt-3 ml-2">
              <b-row>
                <b-col md="4">
                  <label class="labels">First Name</label>
                </b-col>
                <b-col md="8">
                  <p>{{ dataAccount.firstName }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label class="labels">Last Name</label>
                </b-col>
                <b-col md="8">
                  <p>{{ dataAccount.lastName !== null ? dataAccount.lastName : '-' }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label class="labels">Email</label>
                </b-col>
                <b-col md="8">
                  <p>{{ dataAccount.email !== null ? dataAccount.email : '-' }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label class="labels">Address</label>
                </b-col>
                <b-col md="8">
                  <p>{{ dataAccount.address !== null ? dataAccount.address : '-' }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label class="labels">City</label>
                </b-col>
                <b-col md="8">
                  <p>{{ dataAccount.city !== null ? dataAccount.city : '-' }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label class="labels">State</label>
                </b-col>
                <b-col md="8">
                  <p>{{ dataAccount.state !== null ? dataAccount.state : '-' }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label class="labels">Time Zone</label>
                </b-col>
                <b-col md="8">
                  <p>{{ dataAccount.timezone !== null ? dataAccount.timezone : '-' }}</p>
                </b-col>
              </b-row>
            </div>
          </card>
        </b-col>
        <b-col md="6">
          <card class="stacked-form">
            <l-progress v-if="isLoading" :value="100" :height="20" class="mb-2" type="info" :animated="true" :striped="true"></l-progress>
            <div class="mt-3 ml-1">
              <div class="ml-5">
                <label class="labels">Current password *</label>
                <b-form-input name="currentPassword" v-model="model.currentPassword" v-bind:class="errors.has('currentPassword') ? 'is-invalid':''" v-validate="modelValidations.currentPassword" :error="errors.first('currentPassword')" type="password" />
                <slot name="helpBlock">
                  <div class="text-danger invalid-feedback" style="display: block;" v-if="errors.first('currentPassword')">
                    {{ errors.first('currentPassword') }}
                  </div>
                </slot>
                <div v-bind:class="{ 'has-error': errors.first('newPassword') }">
                  <label class="labels mt-3">New password *</label>
                  <b-form-input ref="confirmed:newPassword" name="newPassword" v-model="model.newPassword" v-bind:class="errors.has('newPassword') ? 'is-invalid':''" v-validate="modelValidations.newPassword" :error="errors.first('newPassword')" type="password" />
                  <slot name="helpBlock">
                    <div class="text-danger invalid-feedback" style="display: block;" v-if="errors.first('newPassword')">
                      {{ errors.first('newPassword') }}
                    </div>
                  </slot>
                </div>
                <label class="labels mt-3">Confirm password *</label>
                <b-form-input name="confirmPassword" v-model="model.confirmPassword" v-bind:class="errors.has('confirmPassword') ? 'is-invalid':''" v-validate="modelValidations.confirmPassword" :error="errors.first('confirmPassword')" type="password" />
                <slot name="helpBlock">
                  <div class="text-danger invalid-feedback" style="display: block;" v-if="errors.first('confirmPassword')">
                    {{ errors.first('confirmPassword') }}
                  </div>
                </slot>
              </div>
            </div>
          </card>
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col md="6">
          <b-button variant="secondary" class="btn-back float-left" @click="goBack()"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
        </b-col>
        <b-col md="6">
          <b-button variant="primary" class="btn-back float-right" type="submit"><font-awesome-icon icon="unlock"></font-awesome-icon> Change Password</b-button>
        </b-col>
      </b-row>
    </form>
  </b-card>
</template>

<script>
  export default {
    data () {
      return {
        isLoading: false,
        dataAccount: this.$store.getters['account/accountData'],
        apiUrl: window.AppConfig.apiUrl + 'change-password',
        model: {
          currentPassword: '',
          newPassword: '',
          confirmPassword: ''
        },
        modelValidations: {
          currentPassword: {
            required: true
          },
          newPassword: {
            required: true
          },
          confirmPassword: {
            required: true
          }
        }
      }
    },
    methods: {
      goBack () {
        window.goBack(this)
      },
      doSubmit () {
        this.$validator.validate().then(res => {
          if (res) {
            this.isLoading = true
            this.$http.post(this.apiUrl, this.model).then(response => {
              this.isLoading = false
              this.$store.dispatch('notification/success', 'Password has been changed')
              this.model.currentPassword = ''
              this.model.newPassword = ''
              this.model.confirmPassword = ''
            }).catch(error => {
              this.$store.dispatch('notification/error', error)
            })
          }
        })
      }
    }
  }
</script>